import { Vue } from 'vue-property-decorator';
import { numberFormat, numberFormatWithTextSuffix } from '@/helpers/number-format';
import moment from 'moment';
import { values } from 'd3';
import './questions';
import { COMPETENCY_STATUS } from '@/utils/constants';
import './data-lake.ts';

Vue.filter('avatarText', (value: any) => {
    let avatar = '';
    (value.split(' ')).map((words: any) => {
        avatar += words.toString().charAt(0).toUpperCase();
    });
    return avatar.substr(0, 3);
});

Vue.filter('contentFormator',  (value: any, text: string) => {
    const arrayString = value.split('_') || '';
    const removeString = arrayString.filter((item: string) => item !== text);
    return  removeString.join(' ');
});

Vue.filter('formatNumber', (value: number) => {
    return value ? numberFormat(value) : 0;
});

Vue.filter('percentage', (value: number, total: number) => {
    return Math.round(value * 100 / total);
});

Vue.filter('numtostring', (value: number) => {
    return value ? numberFormatWithTextSuffix(value) : 0;
});

Vue.filter('date', (value: any) => {
    return moment(value).format('ll');
});

Vue.filter('formatDate', (value: any, format: any) => {
    return moment(value).format(format);
});

Vue.filter('competencyStatus', (status: number) => {
    return status >= 0 ? COMPETENCY_STATUS[status] : '';
});

Vue.filter('timestamp', (value: number) => {
    return moment(value).format('LL');
});
